export default {
  filterCommonLoading: "読み込み中...",
  filterCommonNoData: "データなし",

  hiringLocation: "採用場所",
  dateRange: "期間",
  marketGalleries: "ギャラリー",
  marketGalleriesPlaceholder: "ギャラリーを入力",
  marketCategories: "カテゴリー",
  marketCategoriesPlaceholder: "カテゴリーを入力",
  newsLocations: "ニュースの場所",
  publishedDateRange: "公開日",
  industryCategories: "産業カテゴリー",
  industryCategoriesPlaceholder: "産業カテゴリーを入力",
  industrySubCategories: "産業サブカテゴリー",
  sequencePlaceholder: "シーケンス名を入力",
  pageviewGreaterThan: "ページビュー",
  sessionGreaterThan: "セッション",
  advertisements: "広告",
  accountLocation: "アカウントの場所",
  startDate: "開始日",
  endDate: "終了日",
  inputNumberMin: "最小",
  inputNumberMax: "最大",
  postingLocation: "投稿場所",

  filterJob: "求人検索",
  filterJobPostingDateSubTitle: "投稿期間",
  filterJobPostingLocation: "投稿場所",
  filterJobTitlesSubTitle: "役職",

  filterNews: "ニュース",
  filterNewsPublishedDateSubTitle: "公開期間",
  filterNewsCategories: "カテゴリー",

  filterEmployeeCustomRange: "カスタム範囲",

  filterAdvancedSearch: "高度な検索",
  allSearchResultsFor: '"{count}" のすべての検索結果',
  filterAdvancedSearchTooltip:
    "完全一致の単語だけでなく、意味によって結果を検索します。",

  filterSpecialties: "専門分野",
  filterSpecialtiesPlaceHolder: "専門分野を入力",

  filterIndustrySubCategories: "サブ産業",
  filterIndustrySubCategoriesPlaceHolder: "サブ産業を入力",

  filterAdPlaceholder: "広告を入力",

  filterEmployeesPlaceholder: "従業員を選択",

  filterLocationExcludeText: "選択した場所を除外する",
  filterLocationExcludeTooltip:
    "有効にすると、これらの場所が結果からフィルタリングされます。",
  filterManagementPlaceholder: "管理職レベルを入力",

  filterJobFunctionPlaceholder: "職務を入力",

  filterDepartmentPlaceholder: "部門を入力",

  filterPage: "ページ",
  filterPerPage: "1ページあたりの項目数",

  filterCompanyPlaceHolder: "企業を入力",
  filterCompanyCSVImport: "すでにお持ちの企業リストを簡単にインポートする",
  filterCompanyCSVText: "企業リストをインポート (CSV)",

  csvComponentTitle1: "CSVをアップロード",
  csvComponentTitle2: "アップロードの確認",
  csvTipNeedHelp: "ヘルプが必要ですか？",
  detectFileNumber: "{count}件の企業が検出されました",
  uploadLoading: "アップロード中...",
  uploadReplace: "置き換える",
  noCompaniesWereDetectedInYourFile:
    "ファイル内に企業が検出されませんでした。データを確認して再度アップロードしてください。",
  fileContainsManyCompanies:
    "ファイルには多数の企業が含まれていますが、最初の {count}件のみが使用されます。",
  onlyReturnOneResultPerCompany: "企業ごとに1つの結果のみを返す",
  btnViewCompanyList: "企業リストを表示",
  csvFileAnalysisFailed:
    "CSVファイルの分析に失敗しました。後でもう一度お試しください。",
  downloadFailed: "ダウンロードに失敗しました。もう一度お試しください。",
  downloadSampleCsv: "サンプルCSVをダウンロード",
  firstHundredEntriesWillBeProcessed:
    "ファイルごとに最初の{count}件のエントリーのみが処理されます。",
  detectingCompaniesInFile: "ファイル内の企業を検出中...",
  thisMayTakeAFewSeconds: "数秒かかる場合があります。",

  filterSaveText: "検索を保存",
  filterClearAllText: "すべてクリア",

  filterRemoved: "フィルターを削除しました",
};
